<template>
  <v-container fluid class="mainContainer" :style="{ backgroundImage: `url('${baner}')` }"
               @click="redirectToLink">
    <v-row no-gutters>
      <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 8"
             :class="$vuetify.breakpoint.mobile ? '' : 'offset-2'">
        <v-container :class="!$vuetify.breakpoint.mobile ? 'shopBody marginTop' : 'shopBody'">
          <MainPage/>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MainPage from '@/components/Pages/MainPage.vue';
import Axios from '@/core/Axios';
import store from '../../store/index';

export default {
  name: 'MainContainer',
  components: { MainPage },
  data() {
    return {
      baner: '',
      link: '',
      axios: new Axios(),
      url: process.env.VUE_APP_URL,
    };
  },
  mounted() {
    this.axios.makeCall('GET', 'norbit/mainbackground', null, false)
      .then((response) => {
        const banners = Object.values(response.background);
        const numberOfBanners = banners.length;
        if (numberOfBanners > 0) {
          const randomBanner = banners[Math.floor(Math.random() * numberOfBanners)];
          this.baner = `${this.url + randomBanner.file_name}`;
          this.link = randomBanner.link;
          store.commit('updateBaners', [{
            background: banners,
            position1: response.position_1,
            position2: response.position_2,
            position3: response.position_3,
            position4: response.position_4,
          }]);
        }
      });
  },
  methods: {
    redirectToLink() {
      // window.location.href = this.link;
    },
  },
};
</script>

<style scoped>
.mainContainer {
  min-height: 100%;
  background-size: 100% auto;
  background-color: #000000;
  margin-bottom: 5em;
}

.shopBody {
  background: #f2f2f3;
}

.marginTop {
  margin-top: 12em
}
</style>
